module.exports = __webpack_public_path__ + "static/img/testimony1.e8e744c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/testimony1.png
// module id = Qu8b
// module chunks = 1 3